import imageUrlBuilder from '@sanity/image-url';
import { client } from './client';
import type { SanityImageSource } from '@sanity/image-url/lib/types/types';
import createImageUrlBuilder from '@sanity/image-url';

const builder = imageUrlBuilder(client);
const hotspotBuilder = createImageUrlBuilder(client);

export function urlFor(source: SanityImageSource) {
  return builder.image(source);
}

// Pick one aspect for the hero
export const HERO_ASPECT = { w: 16, h: 9 }; // change to {21,9} for panorama
export const GALLERY_ASPECT = { w: 1, h: 1 };

// Next/Image loader: receives width from the browser, returns URL with matching height
export const sanityHeroLoader =
  (img: any, aspect = HERO_ASPECT) =>
  ({ width, quality }: { src: string; width: number; quality?: number }) => {
    const h = Math.round((width * aspect.h) / aspect.w);
    const raw = hotspotBuilder
      .image(img)
      .width(width)
      .height(h)
      .fit('crop')
      .auto('format')
      .quality(quality ?? 75)
      .url();
    return raw;
  };

export const sanityImageSrc = (img: any, opts?: { width?: number | null; height?: number | null }) => {
  if (!img) return '';

  const { width, height } = opts || {};

  let builder = hotspotBuilder.image(img).fit('crop').auto('format');

  if (typeof width === 'number') {
    builder = builder.width(width);
  }

  if (typeof height === 'number') {
    builder = builder.height(height);
  }

  return builder.dpr(2).url();
};
